import { CustomDetailsTextFieldTPV, CustomDisplayProductImageTPV, CustomDisplayProductPriceTPV } from '../SpecificComponents'
import '../SCDashboardTPV.sass'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { TPVOrderData } from '../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/types'
import { TwinDictionary } from '../../../../../../../utils/globals/dictionary'
import TwinTrans from '../../../../../../../baseComponents/TwinTrans'

interface LastAddedProductTPVDSBProps { 
    title: string
    completeData: TPVOrderData | null
}

const LastAddedProductTPVDSB: React.FC<LastAddedProductTPVDSBProps> = ({ title, completeData }) => {
    if (completeData?.lastProductIndex !== null) {
        const lastProduct = completeData?.tableData[completeData.lastProductIndex] 
        if (lastProduct) {
            const myDiscount = parseFloat(lastProduct.discount) ? lastProduct.discount : ''
            return (
                <div className='flex flex-auto flex-col'>
                    <h3 className='pb-15'>{title}</h3>
                    <div className='flex flex-auto h-1 overflow-hidden gap-x-20 last_product_details_content'>
                        <CustomDisplayProductImageTPV name={'product_image'} url={lastProduct.url || lastProduct['Product.Product.ProductImages.url']} id={lastProduct.id} discount={myDiscount} outOfStock={false} typeDiscount={lastProduct.typeDiscount} CurrencyId={completeData?.header?.CurrencyId} />
                        <LastAddedProductDetails product={lastProduct}/>
                    </div>
                </div>
            )
        }
    }
    return (
        <div className='flex flex-col gap-y-10 '>
            <h3 className='pb-15'>{title}</h3>
            <div className='text-gray-9D'><TwinTrans transKey='thereIsNoTAddedProduct'>No hay productos añadidos</TwinTrans></div>
        </div>
    )
}

interface LastAddedProductDetailsProps {
    product: TwinDictionary
}

const LastAddedProductDetails: React.FC<LastAddedProductDetailsProps> = ({ product }) => {
    const { t } = useTwinTranslation()
    const myDiscountedPrice = (product['discount'] && parseFloat(product['discount'])) ? product['finalUnitPriceWithTax'] : null
    return (
        <div className='flex flex-col flex-auto gap-y-5 w-1'>
            <CustomDetailsTextFieldTPV className='regular16 twin_two_lines_elipsis' data={product['Product.ProductLangs.name']} />
            {product['Product.isVariantProduct'] ? <CustomDetailsTextFieldTPV label={t('serie', 'Serie') + ': '} data={product['Product.Product.ProductLangs.name']} /> : null}
            <CustomDetailsTextFieldTPV label={t('referenceShort', 'Ref.') + ': '} data={product['reference'] || product['Product.unique_number']} />
            <div className='flex light14 overflow-hidden mt-5 flex-auto'>
                {product['Product.Product.ProductLangs.shortDescriptionDocuments']}
            </div>
            <CustomDisplayProductPriceTPV price={product['initialUnitPriceWithTax']} discountPrice={myDiscountedPrice} discountClassName='medium18' className='regular16' />
        </div>
    )
}

export default LastAddedProductTPVDSB
